import React from 'react';

import Layout from './layout';

const App: React.FC = () => <Layout />;

export default App;
